import { defineComponent } from "vue";
import { fmtSeconds } from "@com/utils/data-format";
export default defineComponent({
    props: {
        resource: {
            type: Object,
            required: true
        }
    },
    setup: function setup() {
        return {
            fmtSeconds: fmtSeconds
        };
    }
});
